(function () {
  'use strict';

  angular
    .module('app')
    .component('transportationPickupPriceDetail', transportationPickupPriceDetail());

  function transportationPickupPriceDetail() {
    return {
      bindings: {
        transportationPickupPrices: '=',
        transportation: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        zones: '=',
        onTransportationPickupPricesSaved: '&',
        onTransportationPickupPricesCanceled: '&',
      },
      controller: TransportationPickupPriceDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-prices/transportation-pickup-price-detail/transportation-pickup-price-detail.component.html',
    };
  }

  TransportationPickupPriceDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TransportationPriceService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TransportationPickupPriceDetailComponent(
    config,
    UtilService,
    TransportationPriceService,

    // Angular downgraded service
    paxRangeService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.saveTransportationPickupPrices = saveTransportationPickupPrices;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          //selectPaxRange(item);
          setZonesData();
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          //selectPaxRange(paxRangeToSelect);
          setZonesData();
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.transportationPickupPrices.length > 0) {
        // Edit and exists prices
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.transportationPickupPrices[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PICKUP_PRICES';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PICKUP_PRICES';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.transportationPickupPrices.forEach(function (transportationPickupPrice) {
        vm.paxRanges.forEach(function (paxRange) {
          if (
            !checkIfPaxRangeExist(paxRange) &&
            transportationPickupPrice.pax_range_id === paxRange.id
          ) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Set all prices from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.zonesData = [];

      vm.zones.forEach(function (zone) {
        zone.pax_ranges = [];

        vm.paxRanges.forEach(function (paxRange) {
          var transportationPickupPriceId;
          var servicePrice = 0;

          // Exist transportation pickup prices
          if (vm.transportationPickupPrices.length) {
            for (var i = 0; i < vm.transportationPickupPrices.length; i++) {
              var transportationPickupPrice = vm.transportationPickupPrices[i];

              if (
                transportationPickupPrice.zone_id === zone.id &&
                transportationPickupPrice.pax_range_id === paxRange.id
              ) {
                transportationPickupPriceId = transportationPickupPrice.id;

                servicePrice = transportationPickupPrice.service_price;
                break;
              }
            }
          }

          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (paxRange.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          var zonePaxRange = {
            id: paxRange.id,
            service_price: servicePrice,
            pax_from: paxRange.pax_from,
            visible: visible,
            transportationPickupPriceId: null,
          };

          if (transportationPickupPriceId) {
            zonePaxRange.transportationPickupPriceId = transportationPickupPriceId;
          }

          zone.pax_ranges.push(zonePaxRange);
        });

        vm.zonesData.push(zone);
      });
    }

    // Show/hide zone pax ranges, based on the paxRangesSelected
    function setZonesData() {
      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (pax_range.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          pax_range.visible = visible;
        });
      });
    }

    function saveTransportationPickupPrices() {
      var transportationPickupPrices = [];

      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          if (pax_range.visible) {
            var price = {
              service_price: pax_range.service_price || 0,

              zone_id: zone.id,
              pax_range_id: pax_range.id,
              id: null,
            };

            if (pax_range.transportationPickupPriceId) {
              price.id = pax_range.transportationPickupPriceId;
            }

            transportationPickupPrices.push(price);
          }
        });
      });

      var params = {
        transportation_pickup_prices: transportationPickupPrices,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
      };

      vm.sendingForm = true;
      TransportationPriceService.saveTransportationPickupPrices(
        vm.transportation,
        params,
        vm.editMode
      ).then(function (data) {
        vm.onTransportationPickupPricesSaved();

        setItemOptions(data[0].updated_at);

        vm.transportationPickupPrices = data;
        setPaxRangesData();

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTransportationPickupPricesCanceled();
    }
  }
})();
